export enum HttpError {
  UnknownError = 'UnknownError',
  Unauthorized = 'Unauthorized',
  NotFound = 'NotFound',
  RequestTimeout = 'RequestTimeout',
  UnprocessableEntity = 'UnprocessableEntity',
  MissedPermission = 'MissedPermission'
}
